import { CONFIGS } from '@buildwise/libs/configurations';
import { useConfigFilters } from '@buildwise/libs/configurations/hooks';
import useUserData, { UserType } from 'hooks/useUserData';

function usePeopleFilters({ people }: { people: UserType[] }) {
  const { companyId } = useUserData();
  const { filters, isFiltersLoading, clearFilters, setFilters } = useConfigFilters({
    companyId,
    configName: CONFIGS.USER_FILTERS.configName,
    data: people,
    showFiltersCount: true,
  });

  return {
    filters,
    isFiltersLoading,
    clearFilters,
    setFilters,
  };
}

export default usePeopleFilters;
